import { createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '@/shared/ui/empty-state'

export const Route = createFileRoute('/capacity/')({
  component: () => (
    <EmptyState
      icon="bolt"
      title="Выбери заявку"
      description="Слева — заявки на ёмкость; в заявке видно готовые слоты, ожидание линий и поднятые ячейки"
    />
  ),
})
